import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConfigService } from './global-config.service';

@Injectable({
  providedIn: 'root'
})
export class ProcedureService {

  private get baseUrl(): string {
    return this.globalConfig.getApiUrl() + '/services';
  }

  constructor(
    private http: HttpClient,
    private globalConfig: GlobalConfigService
  ) { }

  listProcedures(pageNumber: number, pageSize: number, sortBy: string, orderBy: string, search: string = '') {
    const params: Record<string, string | number> = {
      pageNumber,
      pageSize,
      sortBy,
      orderBy
    };

    const trimmedSearch = search?.trim();
    if (trimmedSearch) {
      params['search'] = trimmedSearch;
    }

    return this.http.get<any>(`${this.baseUrl}`, {
      params
    });
  }

  createProcedure(procedure: any) {
    return this.http.post<any>(`${this.baseUrl}`, procedure);
  }

  getProcedure(procedureId: string) {
    return this.http.get<any>(`${this.baseUrl}/${procedureId}`);
  }

  updateProcedure(id: string, procedure: any) {
    return this.http.put<any>(`${this.baseUrl}/${id}`, procedure);
  }

  deleteProcedure(procedureId: string) {
    return this.http.delete<any>(`${this.baseUrl}/${procedureId}`);
  }
}
